import { Document, Page } from '@react-pdf/renderer';
import './style.css';
import { observer } from 'mobx-react-lite';
import Html from 'react-pdf-html';
import ReactDOMServer from 'react-dom/server';
import { metadataType } from '../../../app/api/types';
import { useEffect, useState } from 'react';
import { useStore } from '../../../app/stores/store';

const GradingQC = () => {
  const {
    viewStore: { metadata, parentMetadata },
    activityStore: { selectedActivity },
  } = useStore();
  const [localMetaData, setLocalMetaData] = useState<any>({});
  const [dynData, setDynData] = useState<any>({});

  useEffect(() => {
    if (selectedActivity?.id) {
      parentMetadata({ itemId: selectedActivity?.id });
    }
    // eslint-disable-next-line
  }, []);

  const element = (
    <html>
      <body>
        <style>
          {`
          * {
              font-size: 8px;
          }
          #container {
            margin: 30px;
          }
          .large-text {
            font-size: 12px;
          }
        img {
              width: 120px;
              height: 45px;
              margin: auto;
        }
        .l-grey-bg {
          background-color: lightgray;
        }
        .grey-bg {
          background-color: gray;
        }
        .nfai-table {
          width: 90%;
          margin-left: auto;
          margin-right: auto;
        }
        .center-content {
          text-align: center;
        }
        .padding-2 {
          padding: 2px;
        }
        .nfai-table,
        .nfai-table th,
        .nfai-table td {
          border: 1px solid black;
          border-collapse: collapse;
        }
        .nfai-table td {
          padding: 2px;
        }
        .nfai-table table,
        .nfai-table table th, .nfai-table table td {
          border: none;
          border-collapse: collapse;
        }
        .white-text {
          color: white;
        }
        .padding-8 {
          padding: 14px 2px;
        }
        `}
        </style>
        <div id="container">
          <table className="nfai-table">
            <tr>
              <td align="center">
                <img src="../assets/PrasadCorp.jpg" alt="Prasad Corp Logo" />
              </td>
              <td
                align="center"
                className="grey-bg padding-8 center-content white-text large-text margin-top-5"
              >
                GRADING - QC REPORT
              </td>
            </tr>
            <tr>
              <td className="l-grey-bg padding-2">TITLE:</td>
              <td className="padding-2">{localMetaData['Film_Title']}</td>
            </tr>
            <tr>
              <td className="l-grey-bg padding-2">CLIENT:</td>
              <td className="padding-2">NFAI</td>
            </tr>
            <tr>
              <td className="l-grey-bg padding-2">LANGUAGE:</td>
              <td className="padding-2">{localMetaData['Language']}</td>
            </tr>
            <tr>
              <td className="l-grey-bg padding-2">NATURE OF SOURCE:</td>
              <td className="padding-2">{`${localMetaData['Resolution']} ${localMetaData['Film Element']}`}</td>
            </tr>
            <tr>
              <td className="l-grey-bg padding-2">FILM TYPE:</td>
              <td className="padding-2">{localMetaData['Type']}</td>
            </tr>
            <tr>
              <td className="l-grey-bg padding-2">FILM GAUGE:</td>
              <td className="padding-2">{localMetaData['Film Gauge']}</td>
            </tr>
            <tr>
              <td className="l-grey-bg padding-2">ASPECT RATIO:</td>
              <td className="padding-2">{localMetaData['Aspect Ratio']}</td>
            </tr>
            <tr>
              <td className="l-grey-bg padding-2">CENSOR CERTIFICATE:</td>
              <td className="padding-2">
                {localMetaData['Censor Certificate']}
              </td>
            </tr>
            <tr>
              <td className="l-grey-bg padding-2">RESOLUTION:</td>
              <td className="padding-2">
                {localMetaData['Resolution Scanned']}
              </td>
            </tr>
            <tr>
              <td className="l-grey-bg padding-2">INPUT FORMAT:</td>
              <td className="padding-2">
                {localMetaData['Input Format/Medium']}
              </td>
            </tr>
            <tr>
              <td className="l-grey-bg padding-2">OUTPUT FORMAT:</td>
              <td className="padding-2">
                {localMetaData['Delivery Format/Medium']}
              </td>
            </tr>
            <tr>
              {dynData['headers']?.map((headerName: string) => {
                return (
                  <th
                    className="center-content padding-2 bold grey-bg white-text"
                    key={headerName}
                  >
                    {headerName}
                  </th>
                );
              })}
            </tr>
            {dynData['body']?.map((bodyData: any) => {
              return (
                <tr>
                  {dynData['headers']?.map((headerName: string) => {
                    return (
                      <td>
                        {typeof bodyData[headerName] === 'object'
                          ? JSON.stringify(bodyData[headerName])
                          : bodyData[headerName]}
                      </td>
                    );
                  })}
                </tr>
              );
            })}
          </table>
        </div>
      </body>
    </html>
  );

  const getDynamicTableData = (eleVal: string) => {
    const temp: any = {};
    temp['headers'] = [];
    temp['body'] = [];
    let columnHeaders: string[] = [];
    let tempValue = [];
    if (eleVal?.includes('DynamicTable|')) {
      let stringData = eleVal?.split('DynamicTable|')?.[1].replaceAll(/\n/g,'');
      stringData = stringData?.split('_')?.join(' ');
      tempValue = stringData !== undefined ? JSON.parse(stringData) : [];
      if (tempValue[0]) {
        columnHeaders = Object.keys(tempValue[0]);
        columnHeaders = columnHeaders?.filter((data) => data !== ' uuid ');
      }
      columnHeaders = columnHeaders?.filter((data) => data !== ' uuid ');
    }
    temp['headers'] = columnHeaders;
    temp['body'] = tempValue;
    setDynData(temp);
  };

  useEffect(() => {
    const tempMetadata: any = {};
    const gradingQCmetadata = [
      'Film_Title',
      'Language',
      'Film Element',
      'Type',
      'Film Gauge',
      'Aspect Ratio',
      'Censor Certificate',
      'Resolution',
      'Resolution Scanned',
      'Input Format/Medium',
      'Delivery Format/Medium',
    ];
    metadata?.forEach((m: metadataType) => {
      if (gradingQCmetadata?.includes(m.elementName)) {
        tempMetadata[m.elementName] = m.elementValue;
      } else if (
        m.elementType === 'DynamicTable' &&
        m.elementName?.includes('Grading Report')
      ) {
        getDynamicTableData(m.elementValue);
      }
    });
    setLocalMetaData(tempMetadata);
  }, [metadata]);

  const html = ReactDOMServer.renderToStaticMarkup(element);
  return (
    <Document>
      <Page style={{ padding: '18px' }}>
        <Html>{html}</Html>
      </Page>
    </Document>
  );
};

export default observer(GradingQC);
